import { css } from '@reown/appkit-ui';
export default css `
  :host {
    width: 100%;
  }
`;
//# sourceMappingURL=styles.js.map